export default __webpack_public_path__ + "static/icon-tile-anatomy-light-1e0df7f6ec1c4aaa898fe62d2cccc8e6b913982c1c4135970005a59fb58134e9.png";